export default {
  setXsrfToken (state, token) {
    state.xsrf_token = token
  }
}
